import React from 'react'
import { Image, ScrollView, StyleSheet, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context';
import Button from 'theme/Button'
import { ThemedValues } from 'styles/themed'
import Icon from 'assets/icon.png';
import i18n from 'utils/i18n'
import Title from 'components/atoms/Title'
import Description from 'components/atoms/Description'
import { colorList } from 'utils/colors'
import HelperVersion from 'utils/helper-version'
import HelperDevelopment from 'utils/helper-development'
import UserService from 'services/user'
import { resetData } from 'services/redux/data/actions'
import { resetManagement } from 'services/redux/management/actions'
import { resetAuthentication } from 'services/redux/authentication/actions'
import { resetCart } from 'services/redux/cart/actions'
import store from 'services/redux/store'
import { appRestart } from 'utils/helper-restart'
import { configClient } from 'components/provider/ConfigProvider'
import * as Sentry from '@sentry/react-native'
import Ajax from 'utils/request/ajax'
import { hideStartupSplash } from 'utils/startup-splash'

export class ErrorBoundary extends React.Component {
	
	state = {
		error: false,
		errorValue: '',
		errorInfo: {},
		errorState: {},
	}
	
	static getDerivedStateFromError( error ) {
		return {
			error: true,
			errorState: error
		};
	}
	
	componentDidCatch (error, errorInfo) {
		// The error UI has committed; do not leave it hidden behind the system splash.
		hideStartupSplash();
		
		// Send to sentry
		Sentry.captureException( error );
		
		// deal with errorInfo if needed
		this.setState({
			errorValue: error,
			errorInfo: errorInfo
		})
		
		// Only send when in dev
		if( !HelperDevelopment.isDev() ) {
			Ajax.request( configClient.url() + '/connection/rest/error/capture', {
				variables: {
					non_encoded_error: error,
					non_encoded_error_info: JSON.stringify( errorInfo ),
					non_encoded_error_state: JSON.stringify( this.state.errorState ),
				}
			});
		}
	}
	
	handleBackToSignIn = async () => {
		appRestart();
	}
	
	onLogout = () => {
		UserService.logout({
			restart: true,
			resetData: () => {
				return store.dispatch(resetData());
			},
			resetManagement: () => {
				return store.dispatch(resetManagement());
			},
			resetAuthentication: () => {
				return store.dispatch(resetAuthentication());
			},
			resetCart: () => {
				return store.dispatch(resetCart());
			},
		});
	}
	
	render () {
		const { error, errorValue, errorInfo, errorState } = this.state;
		
		const forceError = true;
		
		if( error ) {
			return (
				<SafeAreaView>
					<ScrollView>
						<View style={ styles.container }>
							<Image
								style={ styles.headerImage }
								resizeMode="contain"
								source={ Icon }
							/>
							
							<Title>{ i18n.t('error.global.title') }</Title>
							<Description>{ i18n.t('error.global.text') }</Description>
							
							<Button
								onPress={ this.handleBackToSignIn.bind( this ) }>
								
								{ i18n.t('error.global.button') }
							</Button>
							
							<Button
								onPress={ this.onLogout.bind( this ) }
								appearance="ghost">
								
								{ i18n.t( 'buttons.logout' ) }
							</Button>
							
							{ (HelperVersion.isTestVersion() || HelperDevelopment.isDev() || forceError) && (
								<View style={ styles.errorView }>
									<Description>
										{ JSON.stringify( errorValue ) }
									</Description>
									<Description>
										{ JSON.stringify( errorInfo ) }
									</Description>
									<Description>
										{ JSON.stringify( errorState ) }
									</Description>
								</View>
							) }
						</View>
					</ScrollView>
				</SafeAreaView>
			)
		}
		
		return this.props.children;
	}
}

export const styles = StyleSheet.create( {
	headerImage: {
		height: 75,
		width: '100%',
		marginBottom: 20
	},
	container: {
		padding: ThemedValues.marginHorizontal,
	},
	errorView: {
		padding: ThemedValues.marginHorizontal,
		backgroundColor: colorList.GREY.light
	}
})

export default ErrorBoundary;
